export default __webpack_public_path__ + "static/media/gameInfoBg.650c9655.png";